<template>
  <div>
    <div class="bigBox">
      <div style="display: flex;justify-content: center">
        <div style="display: flex;width: 85%;margin-bottom: 20px;justify-content: center;">
          <el-card style="height:80px;width: 100%; border: 1px solid #7f7f7f;" :body-style="{padding:0}">
            <div class="card_label" style="height: 28px; width: 100%; text-align: center;padding-top: 5px">
              货币风险分析
            </div>
            <div class="form">
              <el-form :inline="true"  :model="formInline" class="demo-form-inline">
                <el-form-item >
                  开始时间
                  <el-date-picker  v-model="start_date" type="date" placeholder="年-月-日" size="mini"></el-date-picker>
                </el-form-item>
                <el-form-item >
                  结束时间
                  <el-date-picker
                      v-model="end_date"
                      type="date" placeholder="年-月-日"
                      size="mini">
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button class="grayish_btn" @click="onSubmit" size="mini" style="margin-right: 20px;">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-card>
        </div>
      </div>

      <div style="display: flex;width: 100%;justify-content: space-around;margin-top: 20px">
        <div class="TopBox">
          <div style="display: flex;width: 100%;justify-content: space-around">
            <div  ref="index"  style=" float: left;width: 85%; height: 400px;;"></div>
          </div>
          <div class="bottom-box">
            <div class="warning-component">
              <div class="warning-dates">
                <div class="date-item">前月：<span>{{ prevDayRisk }}</span></div>
                <div class="date-item">上月：<span>{{ yesterdayRisk }}</span></div>
                <div class="date-item">本月：<span>{{ todayRisk }}</span></div>
                <div class="warning-recent">下月：<span>{{ tomorrowRisk }}</span></div>
                <div class="warning-recent">预测准确率：<span>{{ accuracy }}</span></div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import * as echarts from "echarts";
import http from "@/utils/request";
import marketRiskComponent from "@/components/riskIndexComponent.vue";
import axios from "axios";

export default {
  components: {marketRiskComponent},

  data(){
    return {
      formInline: {
        company: '',
        scenario: ''
      },
      start_date:'2022-01-01',
      end_date:'2025-06-01',
      yMax:2,
      yMin:0,
      prevDayRisk:'',
      yesterdayRisk:'',
      todayRisk:'',
      tomorrowRisk:'',
      riskData:[],
      datazoom:[],
      dates:[],
      currency_index:[],
      accuracy:'',
    }
  },

  props:{
    zoom:{
      type:Array,
      default: function () {
        return []
      }
    }
  },
  watch:{
    zoom(newVal){
      this.datazoom=newVal
      console.log(this.datazoom)
    },
    yMax(newVal){
      console.log(newVal)
    }

  },

  mounted() {
    this.end_date=this.getNextMonthFirstDay()
    console.log('下个月的日期是'+this.end_date)

    http.get('/yaliceshi/currency_index/', {
      params: {
        start_date: this.start_date,
        end_date: this.end_date,
      }
    }).then(data => {
      this.dates=data.data.dates;
      this.accuracy=data.data.accuracy
      this.currency_index=data.data.currency_index
      console.log('market_index是'+data.data.currency_index)
      const length=data.data.currency_index.length
      console.log('length'+length)
      this.todayRisk=data.data.currency_index[length-2]
      console.log('market_index是'+data.data.currency_index[length-2])
      this.tomorrowRisk=data.data.currency_index[length-1]
      this.yesterdayRisk=data.data.currency_index[length-3]
      this.prevDayRisk=data.data.currency_index[length-4]
      var series=[];
      series.push({
        data:this.currency_index,
        type:'line',
        name:'货币风险指数',
        smooth:true
      })
      console.log('后端处理成功:', data.data);
      this.initChart(series)
    })
  },
  // 修改日期格式
  computed: {
    formattedStartDate() {
      return this.formatDate(this.start_date);
    },
    formattedEndDate() {
      return this.formatDate(this.end_date);
    }
  },

  methods:{
    // 返回本月的下个月的日期
    getNextMonthFirstDay() {
      const currentDate = new Date();  // 获取当前日期
      const nextMonth = currentDate.getMonth() + 1;  // 获取下个月的月份，注意月份从0开始
      // 设置下个月的1号
      const nextMonthFirstDay = new Date(currentDate.getFullYear(), nextMonth, 1);
      const year = nextMonthFirstDay.getFullYear(); // 获取年份
      const month = (nextMonthFirstDay.getMonth() + 1).toString().padStart(2, '0'); // 获取月份并补充前导零
      const day = nextMonthFirstDay.getDate().toString().padStart(2, '0'); // 获取日期并补充前导零
      return `${year}-${month}-${day}`;  // 返回格式化后的日期
    },

    // 返回一号日期
    formatDate(date) {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = (d.getMonth() + 1).toString().padStart(2, '0');
      const day = '01';
      return `${year}-${month}-${day}`;
    },
    // 提交按钮
    onSubmit(){
      const start_date = this.formattedStartDate;
      const end_date = this.formattedEndDate;
      console.log(start_date)
      http.get('/yaliceshi/currency_index/', {
        params: {
          start_date: start_date,
          end_date: end_date,
        }
      }).then(data => {
        this.currency_index=data.data.currency_index
        this.dates=data.data.dates
        this.updateChart(data.data)
      })
      this.initChart();
    },
    // 跟新图表信息
    updateChart(data){
      var series=[];
      series.push({
        data:data.currency_index,
        type:'line',
        name:'货币风险指数',
        smooth:true
      })
      this.dates=data.dates;
      this.currency_index=data.currency_index;
      console.log('后端处理成功11:', data);
      this.initChart(series);
    },
    // 绘制图表
    initChart(series){
      var myChart = echarts.init(this.$refs["index"])
      let option = {
        title: {
          text: '货币风险指数',
          left:'center'
        },
        grid:{
          show:true,
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },

        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          data: this.dates
        },
        yAxis: {
          scale:true,
          splitLine: {
            show: true
          },
        },

        toolbox: {
          right: 120,
          feature: {
            // dataZoom: {
            //   yAxisIndex: 'none'
            // },
            dataView:{
              show:true,
              title: '查看数据',
            },
            restore: {},
            saveAsImage: {}
          }
        },
        //以下是时间轴
        dataZoom: [{
          //也应该是动态的
          startValue: '2022-07-01'
        }, {
          type: 'inside'
        }],
        //以上是时间轴
        visualMap:{
          show: true,
          type: 'continuous',
          dimension: 0,
          min: 0,
          max: this.dates.length-1
        },
        series: series,

      }
      myChart.setOption(option);
      myChart.dispatchAction({
        type: 'dataZoom',
        batch: [{
          // 第一个 dataZoom 组件
          start: this.datazoom[0],
          end: this.datazoom[1]
        }]
      })
    }
  },

}
</script>

<style scoped>
.bigBox{
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: space-around;
}
.TopBox{
  box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  max-height: 50%;
  flex-direction: column;
  width: 85%;
  border: #453f3f 1px solid;
  justify-content: center;
  border-radius: 10px;
}
.warning-component {
  background-color: #ffffff;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 85%;
  justify-content: space-around;
  text-align: center;
  margin: 10px;

}

.warning-dates {
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.date-item {

  font-weight: bold;
}

.warning-recent {
  color: #ff4d4f;
  font-weight: bold;
  margin-bottom: 10px;
}
.bottom-box{
  width: 100%;
  display: flex;
  justify-content: center;

}
.form{
  display:flex;
  justify-content:space-between;
  margin-top:5px;
  padding-left:40px;
}
.card_label{
  font-size: 13px;
  color:#fff;
  background-color: #7f7f7f;
}
</style>